<template>
  <q-page class="q-pa-sm">
    <div class="row q-col-gutter-sm">
      <div class="col-lg-12 col-md-12 col-xs-12 col-sm-12">
        <q-card class="card-bg no-shadow" bordered>
          <q-form ref="form" @reset="onReset" @submit="onSave">
            <q-card-section class="card-bg-title">
              <div class="text-h6">{{ $t('Change.Password') }}</div>
            </q-card-section>
            <q-card-section class="q-pa-sm">
              <q-item>
                <q-item-section class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                  <q-input
                    v-model="formData.old"
                    :rules="[(val) => (val !== null && val !== '') || $t('errTypePasswd')]"
                    filled
                    :placeholder="$t('oldPassword')"
                    lazy-rules
                    :type="flag.isOldPwd ? 'password' : 'text'"
                    dense
                    bordered
                    dark
                    q-input
                  >
                    <template v-slot:append>
                      <q-icon
                        :name="flag.isOldPwd ? 'mdi-eye-off' : 'mdi-eye'"
                        mdi
                        class="cursor-pointer"
                        @click="flag.isOldPwd = !flag.isOldPwd"
                      />
                    </template>
                  </q-input>
                </q-item-section>
              </q-item>
              <q-item>
                <q-item-section class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                  <q-input
                    v-model="formData.new"
                    :rules="[(val) => (val !== null && val !== '') || $t('errTypePasswd')]"
                    filled
                    :placeholder="$t('newPassword')"
                    lazy-rules
                    :type="flag.isPwd ? 'password' : 'text'"
                    dense
                    bordered
                    dark
                    q-input
                  >
                    <template v-slot:append>
                      <q-icon
                        :name="flag.isPwd ? 'mdi-eye-off' : 'mdi-eye'"
                        mdi
                        class="cursor-pointer"
                        @click="flag.isPwd = !flag.isPwd"
                      />
                    </template>
                  </q-input>
                </q-item-section>
              </q-item>
            </q-card-section>
            <q-card-actions align="left" class="q-pl-lg">
              <q-btn color="primary" :label="$t('add')" type="submit" />
              <q-btn class="q-ml-sm" flat :label="$t('reset')" type="reset" />
            </q-card-actions>
          </q-form>
        </q-card>
      </div>
    </div>
  </q-page>
</template>

<script setup lang="ts">
import { Submit, verifyTFA } from '@/service/settings';
import { reactive, type Ref, ref } from 'vue';
import { QForm, useQuasar } from 'quasar';
import { useI18n } from 'vue-i18n';
import { Reset } from '@/service';
import type { ChangePasswordFormData } from '@/types/request';
import type { TFAResponse } from '@/types/auth';
import { isError } from '@/utils';

const $q = useQuasar();
const { t } = useI18n();

const form = ref() as Ref<QForm>;
const formData = reactive(<ChangePasswordFormData>{});

const flag = ref({
  isOldPwd: true,
  isPwd: true
});

const onReset = () => {
  Reset(formData);
};

const onSave = () => {
  Submit(formData).then(async (response: TFAResponse | Error) => {
    if (isError(response)) {
      return Promise.reject(response);
    }
    if (response.sessionId ?? false) {
      await verifyTFA(response, formData);
    }

    $q.notify({
      color: 'green-4',
      icon: 'mdi-check-circle',
      message: t('successful.saved')
    });
  }).catch((error: Error) => {
    $q.notify({
      color: 'red-4',
      icon: 'mdi-alert-circle',
      message: t(error.toString())
    });
  });
};
</script>
